import { ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { Link } from 'hah-fe-core/dist/components';

const BlogSection = (): ReactElement => {
  const { t: tHome } = useTranslation('', { keyPrefix: '$pages.$home.$blog' });

  return (
    <section id="hp-blog" className="hp-blog hp-section">
      <div className="blog-section">
        <Link
          href={tHome('mainLink')}
          data-event-name="bloc_interact"
          data-bloc-name={tHome('heading')}
        >
          <div className="content-block">
            <h2>{tHome('heading')}</h2>
            <p>{tHome('description')}</p>
            <button className="btn-text" type="button">
              {tHome('cta')} <i className="icon-right-arrow-2" />
            </button>
          </div>
        </Link>
      </div>
      <div className="articles-section">
        <div className="left">
          <Link
            href={tHome('articleLink1')}
            data-event-name="bloc_interact"
            data-bloc-name={tHome('articleHeading1')}
          >
            <picture>
              <source srcSet="images/homePage/banners/hp-blog-section-feature-novotel-desktop.webp" />
              <img
                src="images/homePage/banners/hp-blog-section-feature-novotel-desktop.jpg"
                alt={tHome('cta')}
                width={632}
                height={633}
                loading="lazy"
              />
            </picture>
            <h3>{tHome('articleHeading1')}</h3>
            <p className="description">{tHome('articleDescription1')}</p>
            <button className="btn-text" type="button">
              {tHome('articleCta')}
              <i className="icon-right-arrow-2" />
            </button>
          </Link>
        </div>
        <div className="right">
          <Link
            href={tHome('articleLink5')}
            data-event-name="bloc_interact"
            data-bloc-name={tHome('articleHeading5')}
          >
            <picture>
              <img
                src="images/homePage/banners/hp-blog-section-small-4-novotel-desktop.webp"
                alt={tHome('cta')}
                width={303}
                height={240}
                loading="lazy"
              />
            </picture>
            <h3>{tHome('articleHeading5')}</h3>
            <p className="description">{tHome('articleDescription5')}</p>
            <button className="btn-text" type="button">
              {tHome('articleCta')}
              <i className="icon-right-arrow-2" />
            </button>
          </Link>
          <Link
            href={tHome('articleLink3')}
            data-event-name="bloc_interact"
            data-bloc-name={tHome('articleHeading3')}
          >
            <picture>
              <img
                src="images/homePage/banners/hp-blog-section-small-2-novotel-desktop.webp"
                alt={tHome('cta')}
                width={303}
                height={240}
                loading="lazy"
              />
            </picture>
            <h3>{tHome('articleHeading3')}</h3>
            <p className="description">{tHome('articleDescription3')}</p>
            <button className="btn-text" type="button">
              {tHome('articleCta')}
              <i className="icon-right-arrow-2" />
            </button>
          </Link>
          <Link
            href={tHome('articleLink4')}
            data-event-name="bloc_interact"
            data-bloc-name={tHome('articleHeading4')}
          >
            <picture>
              <img
                src="images/homePage/banners/hp-blog-section-small-3-novotel-desktop.webp"
                alt={tHome('cta')}
                width={303}
                height={240}
                loading="lazy"
              />
            </picture>
            <h3>{tHome('articleHeading4')}</h3>
            <p className="description">{tHome('articleDescription4')}</p>
            <button className="btn-text" type="button">
              {tHome('articleCta')}
              <i className="icon-right-arrow-2" />
            </button>
          </Link>
          <Link
            href={tHome('articleLink2')}
            data-event-name="bloc_interact"
            data-bloc-name={tHome('articleHeading2')}
          >
            <picture>
              <img
                src="images/homePage/banners/hp-blog-section-small-1-novotel-desktop.webp"
                alt={tHome('cta')}
                width={303}
                height={240}
                loading="lazy"
              />
            </picture>
            <h3>
              <Trans
                i18nKey="articleHeading2"
                t={tHome}
                components={{
                  span: <span />,
                }}
              />
            </h3>
            <p className="description">{tHome('articleDescription2')}</p>
            <button className="btn-text" type="button">
              {tHome('articleCta')}
              <i className="icon-right-arrow-2" />
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
